import { useState,useEffect,useCallback } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ApiService from "./../../services/ApiService";
import Pagination from '../../shared/components/Pagination';
import { goBack, convertS3privateToPublic, convertDOBtoAge, convertIntToSuffix } from '../../services/UtilsService';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

const MissedVaccination = () => {
    const [selectedChild, setSelectedChild] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const role = Number(localStorage.getItem('role'));
    const [param, setParam] = useState({ page: 0, limit: 10 });
    const [missedVaccinationList, setMissedVaccinationList] = useState([]);
    const { t } = useTranslation();
    const masterVaccination = useSelector((state) => state?.vaccination);
    const currentLang = localStorage.getItem('i18nextLng');

    // Modal pagination state
    const [modalParam, setModalParam] = useState({ page: 0, limit: 5 }); // Show 3 vaccinations per page in modal
    const [paginatedVaccinations, setPaginatedVaccinations] = useState([]);
    const [totalModalPages, setTotalModalPages] = useState(0);

    //components initialize function and api handling
    useEffect(() => {
    (async () => {
        try {
        // Fetch the physician list
        const response = await ApiService.missedVaccinationList(param);
        if (response.status === 200) {
            setMissedVaccinationList(response.data);
        }
        } catch (error) {
        console.error("Error fetching physician member missed vaccination list:", error);
        }
    })();
    }, [param]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedChild(null);
        setModalParam({ page: 0, limit: 5 }); // Reset modal pagination
        setPaginatedVaccinations([]);
        setTotalModalPages(0);
    };

    // Handle modal pagination
    const handleModalPaginate = (page) => {
        setModalParam(prevParam => ({ ...prevParam, page }));
    };

    // Handle modal items per page change
    const handleModalLimitChange = (limit) => {
        setModalParam({ page: 0, limit: parseInt(limit) });
    };

    /** 
    * To handle search functions
    * @e - we get the event details from the change action
    **/
    const handleChange = async (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setParam({ ...param, [name]: value, page: 0 });
    };

    /** 
    * To handle pagination event
    * @data - we pass the page number
    **/
    const handlePaginate = (data) => {
        setParam({ ...param, page: data });
    };

    // Add this grouping function near the top of your component, after the imports
    const groupVaccinationsByMaster = (vaccinations) => {
        if (!vaccinations || vaccinations.length === 0) return [];
    
        const grouped = vaccinations.reduce((acc, vaccination) => {
        const masterId = vaccination.masterVaccinationId;
        if (!acc[masterId]) {
            acc[masterId] = [];
        }
        acc[masterId].push(vaccination);
        return acc;
        }, {});
    
        return Object.values(grouped);
    }; 

    const renderVaccinationCell = (item) => {
    const groupedVaccinations = groupVaccinationsByMaster(item.vaccinations);
    const hasMultiple = groupedVaccinations.length > 1;
    const firstGroup = groupedVaccinations[0];
 
    if (hasMultiple) {
      return (
        <div
          className="vaccination-cell cursor-pointer"
          onClick={() => handleVaccinationClick(item)}
          style={{ cursor: 'pointer' }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              {firstGroup.map((vaccination, index) => {
                const vac = masterVaccination?.vaccinationName.find(v => v.id === vaccination.vaccineId);
                const type = masterVaccination?.vaccinationType.find(t => t.id === vaccination.typeId && t.vaccineId === vaccination.vaccineId);
               
                return (
                  <div key={index} className={index > 0 ? 'mt-1' : ''}>
                    <span className="fw-medium d-block">
                      {currentLang === 'ta' ? vac?.name_tamil : vac?.name}
                      {" - "}
                      {type ? (currentLang === 'ta' ? type?.name_tamil : type?.name) : ""}
                      {vaccination.dose !== 0 ? (
                        <span>
                          {" " + (vaccination.dose > 4 ? vaccination.dose - 4 : vaccination.dose)}
                          <sup>{convertIntToSuffix(vaccination?.dose)}</sup>
                          {vaccination.dose > 4 ? `${t('modal.booster')}` : `${t('common.dose')}`}
                        </span>
                      ) : (
                        " - Birth "
                      )}
                      {index < firstGroup.length - 1 && <span style ={{textTransform:'none'}}> ({t('modal.or')}) </span>}
                    </span>
                    <span className="badge bg-warning text-dark me-1">
                      {formatDate(vaccination.date)}
                    </span>
                  </div>
                );
              })}
            </div>
            <div className="ms-2">
              <span className="badge bg-primary">+{groupedVaccinations.length - 1} {t('common.more')}</span>
              <i className="ri-arrow-right-s-line ms-1"></i>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="vaccination-cell">
          {firstGroup.map((vaccination, index) => {
            const vac = masterVaccination?.vaccinationName.find(v => v.id === vaccination.vaccineId);
            const type = masterVaccination?.vaccinationType.find(t => t.id === vaccination.typeId && t.vaccineId === vaccination.vaccineId);
           
            return (
              <div key={index} className={index > 0 ? 'mt-1' : ''}>
                <span className="fw-medium d-block">
                  {currentLang === 'ta' ? vac?.name_tamil : vac?.name}
                  {" - "}
                  {type ? (currentLang === 'ta' ? type?.name_tamil : type?.name) : ""}
                  {vaccination.dose !== 0 ? (
                    <span>
                      {" " + (vaccination.dose > 4 ? vaccination.dose - 4 : vaccination.dose)}
                      <sup>{convertIntToSuffix(vaccination?.dose)}</sup>
                      {vaccination.dose > 4 ? `${t('modal.booster')}` : `${t('common.dose')}`}
                    </span>
                  ) : (
                    " - Birth "
                  )}
                  {index < firstGroup.length - 1 && <span style ={{textTransform:'none'}}> ({t('modal.or')})</span>}
                </span>
                <span className="badge bg-warning text-dark me-1">
                  {formatDate(vaccination.date)}
                </span>
              </div>
            );
          })}
        </div>
      );
    }
  };

    // Update the handleVaccinationClick function
  const handleVaccinationClick = (item) => {
    const groupedVaccinations = groupVaccinationsByMaster(item.vaccinations);
    if (groupedVaccinations.length > 1) {
      setSelectedChild({
        ...item,
        groupedVaccinations: groupedVaccinations
      });
      setModalParam({ page: 0, limit: 5 }); // Reset modal pagination
      setShowModal(true);
    }
  };
 
  // Update the paginateModalVaccinations function
  const paginateModalVaccinations = useCallback((groupedVaccinations, page = 0, limit = 5) => {
      if (!groupedVaccinations || groupedVaccinations.length === 0) {
          setPaginatedVaccinations([]);
          setTotalModalPages(0);
          return;
      }
 
      const startIndex = page * limit;
      const endIndex = startIndex + limit;
      const paginatedData = groupedVaccinations.slice(startIndex, endIndex);
      const totalPages = Math.ceil(groupedVaccinations.length / limit);
 
      setPaginatedVaccinations(paginatedData);
      setTotalModalPages(totalPages);
  }, []);
 
  // Update the useEffect for modal pagination
  useEffect(() => {
      if (selectedChild?.groupedVaccinations) {
          paginateModalVaccinations(selectedChild.groupedVaccinations, modalParam.page, modalParam.limit);
      }
  }, [selectedChild, modalParam, paginateModalVaccinations]);

    return (
        <>
            <main id="main" className="main">
                {/* Page Title Section */}
                <div className="pagetitle clearfix">
                    <div className="float-start">
                        <h1>{t('sidebar.missedVaccination')}</h1>
                        <nav>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="index.html">{t('sidebar.home')}</a></li>
                                <li className="breadcrumb-item active">{t('sidebar.missedVaccination')}</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="float-end mt-2 me-1">
                        <a onClick={goBack} className="backIcon">
                            <i className="iconly-Bold-ArrowLeftSquare"></i>
                        </a>
                    </div>
                </div>
                {/* End Page Title Section */}

                {/* Page Content Section */}
                <section className="pagesection">
                    {/* Search */}
                    <div className="row my-3">
                        <div className="col-xxl-7 col-lg-7 d-flex">
                            <div className="input-group input-group-sm me-2 w-50">
                                <input
                                    type="text"
                                    name="search"
                                    className="form-control"
                                    placeholder={t('common.search')}
                                    value={param.search ? param.search : ''}
                                    onChange={handleChange}
                                />
                                <button className={`btn ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'}`} type="button">
                                    <i className="ri-search-line align-middle"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* End Search */}

                    {/* Table */}
                    <div className="row my-3">
                        <div className="col-xxl-12">
                            <div className="table-responsive">
                                <table className="table table-borderless theme-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('table.memberDetails')}</th>
                                            <th scope="col">{t('sidebar.missedVaccination')} & {t('modal.date')}</th>
                                            <th scope="col">{t('sidebar.parent')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {missedVaccinationList?.data?.length > 0 ? (
                                            missedVaccinationList.data.map((item) => (
                                                <tr key={item.id} className={item.child.gender === 0 ? "male" : "female"}>
                                                    <td scope="row">
                                                        <div className="d-flex align-items-center ps-1">
                                                            <div className="avtar-img">
                                                                <span className="rounded-circle">
                                                                    {item?.child?.photo === 'default.png' ? <img src="/assets/img/user-avatar.png" alt="UN" /> : <img src={convertS3privateToPublic(item?.child?.photo)} alt="UN" />}
                                                                </span>
                                                            </div>
                                                            <div className="ms-2">
                                                                {role===4 ? (<Link
                                                                to={"/hospital/admin/view-children/" + item?.id}
                                                                >
                                                                <h5 className="table-title fw-bold">
                                                                    {item.child.name}
                                                                </h5>
                                                                </Link>):(<Link
                                                                to={"/physician/member-profile/" + item?.id}
                                                                >
                                                                <h5 className="table-title fw-bold">
                                                                    {item.child.name}
                                                                </h5>
                                                                </Link>)}
                                                                <p className={`table-subtitle ${role === 4 ? 'admin-table-subtitle' : ''}`}>
                                                                    <span>
                                                                    {item.child.gender === 0 ?  t('common.boy') :  t('common.girl')}
                                                                    </span>{" "}
                                                                    - {convertDOBtoAge(item.child.dob, t)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {renderVaccinationCell(item)}
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <h6 className="mb-1">{item.parent.name}</h6>
                                                            <div className="d-flex align-items-center mb-1">
                                                                <i className="ri-phone-line me-1 text-success"></i>
                                                                <small>{item.parent.phone !== " " && item.parent.phone !== "" ? item.parent.phone : "--"}</small>
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <i className="ri-mail-line me-1 text-primary"></i>
                                                                <small>{item.parent.email !== "" ? item.parent.email : "--"}</small>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                            ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center py-4">
                                                <div className="no-data">
                                                    <p className="text-muted mt-2">{t('common.noRecord')}</p>
                                                </div>
                                                </td>
                                            </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* End Table */}

                    {/*Pagination*/}
                    {missedVaccinationList && missedVaccinationList.length !== 0 && missedVaccinationList?.data?.length !== 0 && <div className="row my-3">
                        <div className="col-xxl-12 d-flex justify-content-center">
                            <Pagination page={param.page} handlePaginate={handlePaginate} total={missedVaccinationList.count} />
                        </div>
                    </div>}
                    {/*End Pagination*/}
                </section>
                {/* End Page Content Section */}
            </main>

            {/* Modal for Multiple Vaccinations */}
            <Modal
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="missed-vaccination-modal"
                centered
                className={`missed-vaccination-modal ${role === 4 ? 'admin-modal' : 'user-modal'}`}
            >
                <Modal.Header closeButton className={role === 4 ? 'admin-modal-header' : ''}>
                    <Modal.Title id="missed-vaccination-modal">
                        <h5 className="modal-title">
                            <i className="ri-syringe-line me-2"></i>
                            {selectedChild?.child?.name}{t('common.possessive_suffix')} {t('sidebar.missedVaccination')}
                        </h5>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="d-flex align-items-center mb-3 pb-3 border-bottom">
                        <div className="avtar-img">
                            <span className="rounded-circle">
                                {selectedChild?.child?.photo === 'default.png' ? <img src="/assets/img/user-avatar.png" alt="UN" /> : <img src={convertS3privateToPublic(selectedChild?.child?.photo)} alt="UN" />}
                            </span>
                        </div>
                        <div className="ms-3">
                            <h6 className="mb-1 text-capitalize">{selectedChild?.child?.name}</h6>
                            <small className="text-muted">{t('table.age')}: {convertDOBtoAge(selectedChild?.child?.dob, t)}</small>
                            <div className="mt-1">
                                <small className="text-muted">{t('sidebar.parent')}: {selectedChild?.parent?.name}</small>
                            </div>
                        </div>
                    </div>

                    <div className="vaccination-list-section">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="mb-3 text-danger">
                                <i className="ri-syringe-line me-1"></i>
                                <i className="ri-error-warning-line text-danger me-2"></i>
                                {t('sidebar.missedVaccination')} ({selectedChild?.groupedVaccinations?.length} {t('common.vaccinations')})
                            </h6>

                            {/* Items per page selector for modal */}
                            <div className="d-flex align-items-center">
                                {/* <small className="text-muted me-2">{t('common.show')}:</small> */}
                                <select 
                                    className="form-select form-select-sm" 
                                    style={{ width: 'auto' }}
                                    value={modalParam.limit}
                                    onChange={(e) => handleModalLimitChange(e.target.value)}
                                >
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                </select>
                                {/* <small className="text-muted ms-2">{t('common.per_page')}</small> */}
                            </div>
                        </div>

                        <div className="vaccination-items-container" style={{ minHeight: '200px' }}>
                            {paginatedVaccinations?.map((vaccinationGroup, groupIndex) => (
                                <div
                                key={`group-${groupIndex}`}
                                className="d-flex justify-content-between align-items-center p-3 mb-2 bg-light rounded vaccination-item position-relative"
                                role="listitem"
                                >                                        
                                <div className="ms-4 flex-grow-1">
                                    {vaccinationGroup.map((vaccination, index) => {
                                    const vac = masterVaccination?.vaccinationName.find(v => v.id === vaccination.vaccineId);
                                    const type = masterVaccination?.vaccinationType.find(t =>
                                        t.id === vaccination.typeId && t.vaccineId === vaccination.vaccineId
                                    );
                                    return (
                                        <div key={`${vaccination.vaccineId}-${vaccination.typeId}-${index}`} className={index > 0 ? 'mt-2 pt-2 border-top' : ''}>
                                        <h6 className="mb-1 fw-medium text-capitalize">
                                            {currentLang === 'ta' ? vac?.name_tamil : vac?.name}
                                            {" - "}
                                            {type ? (currentLang === 'ta' ? type?.name_tamil : type?.name) : ""}
                                            {vaccination.dose !== 0 ? (
                                            <span>
                                                {" " + (vaccination.dose > 4 ? vaccination.dose - 4 : vaccination.dose)}
                                                <sup>{convertIntToSuffix(vaccination?.dose)}</sup>
                                                {vaccination.dose > 4 ? `${t('modal.booster')}` : `${t('common.dose')}`}
                                            </span>
                                            ) : (
                                            ` - ${t('common.birth')}`
                                            )}
                                            {index < vaccinationGroup.length - 1 && (
                                            <span className="fw-normal" style ={{textTransform:'none'}}> ({t('modal.or')})</span>
                                            )}
                                        </h6>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <small className="text-muted">
                                            <i className="ri-calendar-line me-1"></i>
                                            {t('common.scheduledDate')}
                                            </small>
                                            <span className="badge bg-warning text-dark">
                                            {formatDate(vaccination.date)}
                                            </span>
                                        </div>
                                        </div>
                                    );
                                    })}
                                </div>
                                </div>
                            ))}
                        </div>

                        {/* Modal Pagination */}
                        {totalModalPages > 1 && (
                            <div className="d-flex justify-content-center mt-3">
                                <Pagination 
                                    page={modalParam.page} 
                                    handlePaginate={handleModalPaginate} 
                                    total={selectedChild?.groupedVaccinations?.length || 0}
                                    limit={modalParam.limit}
                                />
                            </div>
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" className={`btn btn-sm ${role===4?'btn-tmAquaGreen':'btn-tmPink'}`} onClick={closeModal}>
                        {t('modal.close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default MissedVaccination;